export const gardenCenterButtonImgSrc =
  'https://cdn.lemanapro.ru/lmru/image/upload/v1724399174/fudzi/navigation-microfronts/lemana/gardenflower.png/gardenflower.png';
export const buildingYardButtonImgSrc =
  'https://cdn.lemanapro.ru/lmru/image/upload/v1724399174/fudzi/navigation-microfronts/lemana/buildhouse.png/buildhouse.png';
export const gardenCenterModalImgSrc =
  'https://cdn.lemanapro.ru/lmru/image/upload/v1724399174/fudzi/navigation-microfronts/lemana/garden_center.png/garden_center.png';
export const buildingYardModalImgSrc =
  'https://cdn.lemanapro.ru/lmru/image/upload/v1724399174/fudzi/navigation-microfronts/lemana/building_yard.png/building_yard.png';

export const gardenCenterString = 'Садовый центр';
export const buildingYardString = 'Строительный центр';

export const DATA_QA_STORE_GC_BY = 'store-garden-center-building-yard';
export const DATA_QA_OPERATIONAL_TIME_BUTTON = 'operational-time-button';
export const DATA_QA_OPERATIONAL_TIME_BUTTON_PICTURE = 'operational-time-button-picture';
export const DATA_QA_OPERATIONAL_TIME_MODAL_PICTURE = 'operational-time-modal-picture';
export const DATA_QA_OPERATIONAL_TIME_MODAL_BACK_BUTTON = 'operational-time-modal-back-button';

export const GARDEN_CENTER_MODAL_LINK_PARAMETER = 'gc_show';
export const BUILDING_YARD_MODAL_LINK_PARAMETER = 'by_show';
